// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"4cd0a4b7730e1b61c310","263":"082a67c3af29c4c18dbd","791":"eddaa795ea551f214823"}[chunkId] + ".js";
};